// getMyNewsItem
import gql from "graphql-tag";

export const MY_NEWS_GET_ITEM = gql`
  query getMyNewsItem($_id: String!) {
    getMyNewsItem(_id: $_id) {
      _id
      title
      description
      content
      priority
      validFrom
      validTo
      createdAt
      createdBy
      publishedAt
      read
      editorEmployeeCode
      editorName
      modifiedAt
      modifiedBy
    }
  }
`;
